import React from 'react';
import { OutlinedIcons } from '@marageti/z4-lib';
import {
  AuditCategory,
  EntityType,
  SalesStage,
  SalesStageAction,
} from './types';

const {
  OutlinedCloudIcon,
  OutlinedClockIcon,
  OutlinedTrendingUpIcon,
  OutlinedEyeIcon,
} = OutlinedIcons;

export const AUDIT_CATEGORIES: AuditCategory[] = [
  {
    id: 'events',
    label: 'API Events',
    description:
      'Logs of all API calls made to the system. Tracks HTTP method, status, user, and affected entities.',
    path: 'events',
    icon: <OutlinedCloudIcon />,
  },
  {
    id: 'versions',
    label: 'Entity Versions',
    description:
      'Version history for entities like Trip Requests, Trip Matches, Partners, and Reviews. Every modification creates a new version.',
    path: 'versions',
    icon: <OutlinedClockIcon />,
  },
  {
    id: 'sales-stage',
    label: 'Sales Stages',
    description:
      'Audit trail of sales stage changes on Trip Matches. Tracks stage transitions, due dates, and agent actions.',
    path: 'sales-stage',
    icon: <OutlinedTrendingUpIcon />,
  },
  {
    id: 'views',
    label: 'Page views',
    description:
      'Web page view tracking. Records device info, location, referrer, UTM tags, and user journey.',
    path: 'views',
    icon: <OutlinedEyeIcon />,
  },
];

export const ENTITY_TYPES: { label: string; value: EntityType }[] = [
  { label: 'Trip Requests', value: 'trip_requests' },
  { label: 'Trip Matches', value: 'trip_matches' },
  { label: 'Partners', value: 'partners' },
  { label: 'Agents', value: 'agents' },
  { label: 'Travelers', value: 'travelers' },
  { label: 'Users', value: 'users' },
  { label: 'Reviews', value: 'reviews' },
];

export const SALES_STAGES: { label: string; value: SalesStage }[] = [
  { label: 'First Message Sent', value: 'FIRST_MESSAGE_SENT' },
  { label: 'Consultation', value: 'CONSULTATION' },
  { label: 'Itinerary Sent', value: 'ITINERARY_SENT' },
  { label: 'Itinerary In Review', value: 'ITINERARY_IN_REVIEW' },
];

export const SALES_STAGE_ACTIONS: { label: string; value: SalesStageAction }[] = [
  { label: 'Stage Updated', value: 'STAGE_UPDATED' },
  { label: 'Reminder Completed', value: 'REMINDER_COMPLETED' },
  { label: 'Reminder Dismissed', value: 'REMINDER_DISMISSED' },
  { label: 'Reminder Snoozed', value: 'REMINDER_SNOOZED' },
];

export const LIMIT_OPTIONS = [
  { label: '10', value: 10 },
  { label: '50', value: 50 },
  { label: '100', value: 100 },
];

export const DEFAULT_LIMIT = 50;

export const LOG_LEVELS = [
  { label: 'Info', value: 'INFO' },
  { label: 'Error', value: 'ERROR' },
];

/** GitHub-style diff colors for version comparison (no direct MUI equivalents) */
export const DIFF_COLORS = {
  added: { bg: '#e6ffec', text: '#1a7f37' },
  removed: { bg: '#ffebe9', text: '#cf222e' },
  chipModified: { bg: '#fff8c5', text: '#9a6700' },
};
